import { useParams } from 'react-router-dom';
import KnowledgeArticlePage from '../components/KnowledgeArticlePage';
import { AUTO_INSURANCE_CONFIG } from '../data/autoArticles';

function AutoKnowledgeArticleRoute() {
  const { slug } = useParams<{ slug: string }>();

  return <KnowledgeArticlePage config={AUTO_INSURANCE_CONFIG} slug={slug ?? ''} />;
}

export default AutoKnowledgeArticleRoute;
